<template>
	<div :class='"clearfix " + actorProperty.property.color'>
		<div
			v-if="!hideColorBox"
			class="property-color-box pull-left ext-margin-base-right"
		></div>
		<div v-if="!hideName" class="property-name pull-left">
			{{ actorProperty.property.names[locale] }}
		</div>
		<div
			:class='"PropertyBarInfo__value-text" + (hideColorBox ? "" : " pull-right text-right")'
		>
			<animated-number
				v-if="!valueUnit && !comparisonAPs"
				:prev-number="actorProperty.old_current_value || valueToShow"
				:number="valueToShow"
				:animation-duration="2"
				:show-floating-comma="comparisonAPs !== undefined"
			></animated-number>
			<span v-if="valueUnit">{{ formattedAsCurrency(valueToShow) }}</span>
			<animated-number
				v-if="!valueUnit && comparisonAPs"
				:prev-number="comparisonAPs ? valueToShow : (actorProperty.old_current_value || actorProperty.current_value)"
				:number="valueToShow"
				:srv-numeral-format="srvNumeralFormat"
			></animated-number>
			<span v-if="comparisonAPs">%</span>
		</div>
	</div>
</template>

<script>
import { i18n } from "../utils";
import AnimatedNumber from "./animated_number.vue";

export default {
	mixins: [i18n],
	props: {
		srvPropertyTypeKey: String,
		srvComparisonPropertyTypeKeys: Object,
		actorId: String,
		comparisonActorId: Number,
		phaseId: Number,
		// NB this won't do anything if the Property has no `value_unit` is set to false
		formatCurrencyWithUnit: {
			type: Boolean,
			default: false,
		},
		hideName: Boolean,
		hideColorBox: Boolean,
		srvNumeralFormat: String,
	},
	data: function () {
		return {
			locale: I18n.locale,
		};
	},
	components: {
		"animated-number": AnimatedNumber,
	},
	computed: {
		actorProperty: function () {
			return VueStore.getters.actorPropertyOfTypeFor(
				this.actorId,
				this.srvPropertyTypeKey,
			);
		},
		comparisonAPs: function () {
			if (
				this.srvComparisonPropertyTypeKeys !== undefined &&
				this.comparisonActorId
			) {
				return VueStore.getters.actorsPropertiesOfTypeFor(
					this.comparisonActorId,
					this.srvComparisonPropertyTypeKeys,
				);
			}
			// else
			return undefined;
		},
		phaseCurrentValue: function () {
			return this.actorProperty.values[this.phaseId].current_value;
		},
		valueToShow: function () {
			if (this.comparisonAPs) {
				const comparisonSum = this.comparisonAPs
					// @ts-expect-error
					.map((ap) => ap.values[this.phaseId].current_value)
					.reduce((a, b) => a + b, 0);
				return ((this.phaseCurrentValue / comparisonSum) * 100).toFixed(2);
			}
			// else
			return this.phaseCurrentValue;
		},
		valueUnit: function () {
			return this.comparisonAPs
				? undefined
				: this.actorProperty.property.value_units[I18n.locale];
		},
		numeralFormatToUse: function () {
			return (
				this.srvNumeralFormat ||
				(this.formatCurrencyWithUnit && this.valueToShow >= 10000
					? numeral.formatWithUnit
					: numeral.format)
			);
		},
	},
	mounted() {},
	beforeDestroy() {},
	methods: {
		formattedAsCurrency(number) {
			let toReturn = numeral(number).format(this.numeralFormatToUse);

			if (this.valueUnit !== undefined) {
				if (
					this.valueUnit.length > 1 ||
					this.numeralFormatToUse == numeral.formatWithUnit
				) {
					toReturn += " ";
				}
				toReturn += this.valueUnit;
			}
			return toReturn;
		},
	},
};
</script>
